import {Injectable, NgZone} from '@angular/core';
import { Router } from '@angular/router';
import {AuthService} from './auth-service.service';

@Injectable()
export class AuthGuardService  {

	constructor(public router: Router, private zone: NgZone, private authService: AuthService) {}

	canActivate(): boolean {
		if (!this.authService.is_authenticated()) {
			
			this.zone.run(() => {
				
				this.router.navigate(['/']);
				
			});
			return false;
		}
		return true;
	}
}
